export const countUniqueSearchesOnSearchId = {
  analysisType: 'count_unique',
  eventCollection: 'kb.search.view',
  key: 'countUniqueSearchesOnSearchId',
  targetProperty: 'search.id',
}
